module.exports = "<div class=\"form-group\" [ngClass]=\"{ 'invalid': isInvalid, 'valid': isValid, 'required': isRequired }\">\n    <label [htmlFor]=\"id\" [ngClass]=\"'has-value'\"> {{ label }} </label>\n    <select [id]=\"id\" class=\"form-control custom-select focus-outline\" [(ngModel)]=\"value\">\n      <option [value]=\"undefined\" hidden>{{ hiddenOptionLabel || 'Veuillez sélectionner une valeur' }}</option>\n      <option *ngFor=\"let option of options\" [value]=\"option.value\"> {{ option.label }} </option>\n    </select>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/shared/components/forms/select/select.component.html
// module id = 848
// module chunks = 0